if (!customElements.get("upsell-current-month")) {
  customElements.define(
    "upsell-current-month",
    class SubscriptionWidget extends HTMLElement {
      
      constructor() {
        super();
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.form = document.querySelector('form.form[action="/cart/add"]');
        this.upsellVariantId = this.checkbox.dataset.id;
        this.upsellSellingPlanId = this.checkbox.dataset.sellingPlanId;
        this.cartBtn = this.form.querySelector('button[type="submit"][name="add"]');
        this.cartBtn.addEventListener("click", this.handleFormSubmit);
        document.addEventListener('rebuy:cart.add', (event) => { 
          this.setCartBtnLoading(false);
        });
      }

      setCartBtnLoading(loading) {
        if(loading) {
          this.cartBtn.classList.add('loading');
          this.cartBtn.setAttribute('disabled', true);
          this.cartBtn.querySelector('.loading__spinner').classList.remove('hidden');
          return;
        }

        this.cartBtn.classList.remove('loading');
        this.cartBtn.removeAttribute('disabled');
        this.cartBtn.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleFormSubmit(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        const data = new FormData(this.form);
        const value = Object.fromEntries(data.entries());
        const mainProductId = value.id;
        const mainProductSellingPlan = value.selling_plan;
        const items = [];
        if (this.checkbox.checked) {
          items.push({
            id: this.upsellVariantId,
            selling_plan: this.upsellSellingPlanId,
            quantity: 1
          });
        }

        items.push({
          id: mainProductId,
          selling_plan: mainProductSellingPlan || document.querySelector('input[name="subscription-type"]:checked')?.dataset?.sellingPlanId,
          quantity: 1
        });

        this.setCartBtnLoading(true);
        Rebuy.Cart.addItem({items});
        return false;
      }
    }
  );
}
